import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { tGlobal, tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.settings.organization.users');

type UserCantInviteDialogProps = {
  dialogCantInviteState: boolean;
  setDialogCantInviteState: (state: boolean) => void;
  handleRedirectToBilling: () => void;
};

export function UserCantInviteDialog(props: UserCantInviteDialogProps) {
  const { dialogCantInviteState, setDialogCantInviteState, handleRedirectToBilling } = props;

  return (
    <Dialog open={dialogCantInviteState} onOpenChange={setDialogCantInviteState}>
      <DialogContent hasCloseButton>
        <DialogTitle>{t('updateYourPlan')}</DialogTitle>
        <DialogDescription>{t('updateToBusinessDescription')}</DialogDescription>
        <DialogFooter isColumn>
          <Button
            variant="outline"
            size="xl"
            className="w-full"
            onClick={function () {
              setDialogCantInviteState(false);
            }}
          >
            {tGlobal('cancel')}
          </Button>
          <Button
            size="xl"
            variant="accent"
            className="w-full"
            onClick={function () {
              void handleRedirectToBilling();
            }}
          >
            {tGlobal('upgradePlan')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
